import { WalkthroughImages } from './models';
import { InjectionToken } from '@angular/core';
import { IonicComponentRef } from '@lyceo/shared/util-models';

export const WALKTHROUGH_MODAL: InjectionToken<IonicComponentRef> =
  new InjectionToken<IonicComponentRef>('WALKTHROUGH_MODAL');

const pupilPlanDesktopImages: string[] = [
  'plan/desktop_1.png',
  'plan/desktop_2.png',
  'plan/desktop_3.png',
  'plan/desktop_4.png',
  'plan/desktop_5.png',
  'plan/desktop_6.png',
  'plan/desktop_7.png',
  'plan/desktop_8.png',
  'plan/desktop_9.png',
  'plan/desktop_10.png',
  'plan/desktop_11.png',
];

const pupilPlanMobileImages: string[] = [
  'plan/mobile_1.png',
  'plan/mobile_2.png',
  'plan/mobile_3.png',
  'plan/mobile_4.png',
  'plan/mobile_5.png',
  'plan/mobile_6.png',
  'plan/mobile_7.png',
  'plan/mobile_8.png',
  'plan/mobile_9.png',
  'plan/mobile_10.png',
  'plan/mobile_11.png',
  'plan/mobile_12.png',
  'plan/mobile_13.png',
];

const instructorPlanDesktopImages: string[] = [
  'instructor/desktop_1.jpg',
  'instructor/desktop_2.jpg',
  'instructor/desktop_3.jpg',
  'instructor/desktop_4.jpg',
];

const instructorPlanMobileImages: string[] = [...instructorPlanDesktopImages];

export const pupilPlanImages: WalkthroughImages = {
  desktop: pupilPlanDesktopImages,
  mobile: pupilPlanMobileImages,
};

export const instructorPlanImages: WalkthroughImages = {
  desktop: [...instructorPlanDesktopImages, ...pupilPlanDesktopImages],
  mobile: [...instructorPlanMobileImages, ...pupilPlanMobileImages],
};

const pupilPractiseDesktopImages: string[] = [
  'practise/desktop_1.png',
  'practise/desktop_2.png',
  'practise/desktop_3.png',
  'practise/desktop_4.png',
  'practise/desktop_5.png',
  'practise/desktop_6.png',
  'practise/desktop_7.png',
  'practise/desktop_8.png',
];

const pupilPractiseMobileImages: string[] = [
  'practise/mobile_1.png',
  'practise/mobile_2.png',
  'practise/mobile_3.png',
  'practise/mobile_4.png',
  'practise/mobile_5.png',
  'practise/mobile_6.png',
  'practise/mobile_7.png',
  'practise/mobile_8.png',
  'practise/mobile_9.png',
  'practise/mobile_10.png',
];

export const pupilPractiseImages: WalkthroughImages = {
  desktop: pupilPractiseDesktopImages,
  mobile: pupilPractiseMobileImages,
};

const pupilPlanPractiseDesktopImages: string[] = [
  'plan-practise/desktop_1.png',
  'plan-practise/desktop_2.png',
  'plan/desktop_3.png',
  'plan/desktop_4.png',
  'plan/desktop_5.png',
  'plan/desktop_6.png',
  'plan/desktop_7.png',
  'plan/desktop_8.png',
  'plan/desktop_9.png',
  'plan/desktop_10.png',
  'practise/desktop_3.png',
  'practise/desktop_4.png',
  'practise/desktop_5.png',
  'practise/desktop_6.png',
  'practise/desktop_7.png',
  'practise/desktop_8.png',
];

const pupilPlanPractiseMobileImages: string[] = [
  'plan-practise/mobile_1.png',
  'plan-practise/mobile_2.png',
  'plan-practise/mobile_3.png',
  'plan-practise/mobile_4.png',
  'plan/mobile_4.png',
  'plan/mobile_5.png',
  'plan/mobile_6.png',
  'plan/mobile_7.png',
  'plan/mobile_8.png',
  'plan/mobile_9.png',
  'plan/mobile_10.png',
  'plan/mobile_11.png',
  'plan/mobile_12.png',
  'practise/mobile_3.png',
  'practise/mobile_4.png',
  'practise/mobile_5.png',
  'practise/mobile_6.png',
  'practise/mobile_7.png',
  'practise/mobile_8.png',
  'practise/mobile_9.png',
  'practise/mobile_10.png',
];

export const pupilPlanPractiseImages: WalkthroughImages = {
  desktop: pupilPlanPractiseDesktopImages,
  mobile: pupilPlanPractiseMobileImages,
};
